import { useState } from "react";

import { motion } from "motion/react";

interface CurrencySwitcherProps {
  onSwitch?: (value: "USD" | "RUB") => void;
  defaultCurrency?: "USD" | "RUB";
}

export default function CurrencySwitcher({
  onSwitch,
  defaultCurrency = "USD",
}: CurrencySwitcherProps) {
  const [currency, setCurrency] = useState<"USD" | "RUB">(defaultCurrency);

  const handleSwitch = (value: "USD" | "RUB") => {
    setCurrency(value);
    if (onSwitch) {
      onSwitch(value);
    }
  };

  return (
    <div className="flex items-center justify-center">
      <div className="relative flex h-[30px] w-[64px] rounded-full bg-gray-100 dark:bg-[#191919]">
        <motion.div
          layout
          transition={{ type: "spring", stiffness: 300, damping: 25 }}
          className={`absolute -bottom-[1px] -top-[1px] aspect-square rounded-full bg-black dark:bg-white`}
          style={{
            left: currency === "USD" ? "0.3px" : "31.9px",
          }}
        />

        <button
          onClick={() => handleSwitch("USD")}
          className={`relative z-10 flex flex-1 items-center justify-center rounded-full text-[12px] transition-colors duration-300 ${
            currency === "USD"
              ? "text-white dark:text-black"
              : "text-black opacity-60 dark:text-white"
          }`}
        >
          $
        </button>

        <button
          onClick={() => handleSwitch("RUB")}
          className={`relative z-10 flex flex-1 items-center justify-center rounded-full text-[12px] transition-colors duration-300 ${
            currency === "RUB"
              ? "text-white dark:text-black"
              : "text-black opacity-60 dark:text-white"
          }`}
        >
          ₽
        </button>
      </div>
    </div>
  );
}
